

import { ref, reactive, watch, onBeforeMount, computed, onMounted, onUnmounted } from 'vue';
import Button from '@/components/ui/button/index.vue';
import CardInfo from '@/components/ui/cardinfo/index.vue';
import ContentGroup from '@/components/ui/contentgroup/index.vue';
import Table from '@/components/ui/tablebox/index.vue';
import Tab from '@/components/ui/tab/index.vue';
import TableInfo from '@/components/ui/tableinfo/index.vue';
import Select from '@/components/ui/select/index.vue';
import CTmenu from '@/components/ui/ctmenu/index.vue';
import Input from '@/components/ui/input/index.vue';
import Pagination from '@/components/ui/pagination/index.vue';
import FlashMsg from '@/components/ui/flashMsg/index.vue';
import Switcher from '@/components/ui/switcher/index.vue';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';

import { ERRORDESC, BTN, ACTIONBAR, POPUP, CONNECTION, REPEAT_TYPE, FEATURENAME, BRIGHTNESSUNIT, BRIGHTNESSMAX, UNIT, USERMODE } from '../../../enum/enum';
import { useStore } from 'vuex';
import { dateTimeHandle } from '@/utils/time';
import { colorGamutHandler, dynamicRangeHandler, eotfHander } from '@/utils/attribute';

import { apiDeleteDevice, apiDeviceGetProfile, apiDeviceProfile, apiDeviceSetting, apiCSV, apiDeviceExecutedData, apiSettings, apiGetGroupModel, apiDeleteTask, apiDeviceApp, apiDeleteAppointment } from '@/api/api';

export default {
  name: 'devicedetail',
  components: {
    Button,
    CardInfo,
    ContentGroup,
    Tab,
    Select,
    Table,
    TableInfo,
    CTmenu,
    Pagination,
    Input,
    FlashMsg,
    Switcher
  },
  props: {

  },
  setup() {
    const { t } = useI18n();



    const route = useRouter()
    // const fatherLink = route.currentRoute.value.fullPath


    const state = reactive({
      title: [
        {
          title: 'User Mode',
          key: 'userMode',
        }
      ],
      form:
      {
        userMode1: {
          text: '請選擇',
          val: 'default',
        },
        userMode2: {
          text: '請選擇',
          val: 'default',
        },
        preset: {
          text: '請選擇',
          val: 'default',
        },
        preset7091: {
          text: '請選擇',
          val: 'default',
        },
        preset7092: {
          text: '請選擇',
          val: 'default',
        },
        preset2020: '',
        rgb: '',
        dicom1: {
          text: '請選擇',
          val: 'default',
        },
        dicom2: {
          text: '請選擇',
          val: 'default',
        },
      },
      formError:
      {
        userMode1: false,
        userMode2: false,
        preset: false,
        preset7091: false,
        preset7092: false,
        preset2020: false,
        rgb: false,
        dicom1: false,
        dicom2: false,
      }
      ,
      formDisable: {
        userMode1: false,
        userMode2: false,
        preset: false,
        preset7091: false,
        preset7092: false,
        preset2020: false,
        rgb: false,
        dicom1: false,
        dicom2: false,
      },
      settingIcon: [
        {
          key: 'calibration',
          status: true,
          text: '__d4e_m8t.__setACalibrationOrAppointmentTask',
        },
        {
          key: 'application',
          status: true,
          text: '__d4e_m8t.__applyOsdSettings',
        }
      ],
      iconStatus: {
        // asus_proart_sw_ico_lock:
      },
      etOption: [
        {
          text: t('__d4e_m8t.__allTasks'),
          val: '',
          isI18n: '__d4e_m8t.__allTasks',
        },
        {
          text: t('__d4e_m8t.__implementationStatus'),
          val: 'status',
          isI18n: '__d4e_m8t.__implementationStatus',
          sub: [
            {
              text: t('__common.__success'),
              val: '1',
              isI18n: '__common.__success',
            },
            {
              text: t('__common.__fail'),
              val: '0',
              isI18n: '__common.__fail',
            },
            {
              text: t('__d7d_n17r.__waitingForReply'),
              val: '2',
              isI18n: '__d7d_n17r.__waitingForReply',
            },
          ]
        },
      ],
      apOption: [
        {
          text: t('__d4e_m8t.__allAppointments'),
          val: '',
          isI18n: '__d4e_m8t.__allAppointments',
        },
      ],
      meta: {
        total_page: 1,
        current: 1,
        per_page: 12,
      },
      isTabShow: ACTIONBAR.VIEWHIS,
      selectVal1: {
        text: 'All Tasks',
        val: '',
      },
      appListData: [],


      exeListData: [],

      modelData: {},
      modelCol: [
        {
          title: '__d7d_n17r.__serialNumber',
          val: 'ssn',
        },
        {
          title: '__d7d_n17r.__pcName',
          val: 'host',
        },
        {
          title: '__common.__group',
          val: 'group',
        },
        {
          title: '__d4e_m8t.__addDate',
          val: 'bound_at',
        },
        {
          title: '__d7d_n17r.__ipAddress',
          val: 'ip',
        },
        {
          title: '__d7d_n17r.__connectionStatus',
          val: 'status',
        },
      ],
      order: 'desc',
      sort: '',
      preset: [], //appointment mapping，預設值列表
      calibrators: [], //Calibrator Type
      colorRange: [], //setting傳回來的資料
      eotf: [], // eotf列表
      gamut: [], // gamut列表
      list: [],//打勾的列表
      applyDisable: true,
      modelList: [], //mapping list
      rawData: {},
      profileList: [],
      compare: [], //osd profile 在送出請前先比對有沒有改東西用的陣列
      deviceCheck: [
        // {
        //   title: 'Preset User Mode 1',
        //   name: 'user1',
        //   val: false,
        // },
        // {
        //   title: 'Preset User Mode 2',
        //   name: 'user2',
        //   val: false,
        // },
        // {
        //   title: 'All ProArt ProArt Preset',
        //   name: 'all',
        //   val: false,
        // }
      ],
      detail: '',
      left: null,
      top: null,
      waitForProfile: false, //等待profile送出後更新(需要10分鐘)，此時profile不能被編輯
      showLimitInfo: false, //show 上方資料滑鼠hover的detail內容
      tableETDisableList: [],
      tableAPDisableList: [],
      modelName: '',
      consoleLog: false,
      defaultCheckIndexList: [], //default check list execute task & appointemtnt
      noChange: true, //沒有改訂過osd profile 的下拉選單

    })

    const deviceDetailPage = ref();
    // console.log(deviceDetailPage,'uiuiu')

    onBeforeMount(async () => {

      let a = route.currentRoute.value.params.tabId;
      state.isTabShow = `${a}`;
      await pageSettingInit()
      await apiPost();
      await queryModels();
      textLimitHoverPopup()
      window.addEventListener("resize", (() => {
        textLimitHoverPopup()
      }));
    })

    let interval = null;

    onMounted(() => {
      interval = setInterval(() => {
        if (state.isTabShow === ACTIONBAR.VIEWAPP || state.isTabShow === ACTIONBAR.VIEWHIS) {
          apiPost(false);
        }// end: if 
      }, storeState.updateTime);

    })

    const brand = computed(()=> storeState.brand)

    onUnmounted(() => {
      clearInterval(interval);
    })

    const tabText = computed(() => {
      return [{
        name: t('__d4e_m8t.__executedTasks'),
        val: ACTIONBAR.VIEWHIS,
        disabled: false,
      }, {
        name: t('__g3p_m8t.__appointment'),
        val: ACTIONBAR.VIEWAPP,
        disabled: false,
      }, {
        name: t('__d4e_m8t.__settings'),
        val: ACTIONBAR.SETTING,
        disabled: false,
      }]

    })

    const appListCol = computed(() => {
      return [
        {
          title: t('__d4e_m8t.__setDate'),
          key: "updated_at",
          sort: true,
        },
        {
          title: t('__d4e_m8t.__repeat'),
          key: "repeatCol",
          customRender: "repeatColData",
          sort: true,
        },
        {
          title: t('__d4e_m8t.__upcomingCalibrationDate'),
          key: "next_timestamp",
          sort: true,
        },
        {
          title: t('__d4e_m8t.__time'),
          key: "time",
          sort: true,
        },
        {
          title: t('__d4e_m8t.__groupAppointment'),
          key: "group",
          sort: true,
        },
        {
          title: t('__common.__modify'),
          customRender: "modify", //客製化slot，可用於外接其他組件
          key: "modify",
        },
      ]

    })

    //ExecutedData
    const exeListCol = computed(() => {
      return [
        {
          title: t('__d4e_m8t.__implementDate'),
          key: "action_timestamp",
          sort: true,
        },
        {
          title: t('__common.__mode'),
          key: "mode2",
          customRender: "modeColData",
          sort: true,
        },
        {
          title: t('__g3p_m8t.__dynamicRange'),
          key: "color_range",
          sort: true,
        },
        {
          title: t('__d4e_m8t.__profileName'),
          key: "profile_name",
          clickPopUp: 'profile_name_detail', //可以點擊出現選單，參數請設定需要被綁進Popup的key值
          clickPopUpIcon: 'asus_proart_sw_ico_arrow_s3', //此為default
          sort: true,
        },
        {
          title: t('__d4e_m8t.__implementationStatus'),
          key: "status",
          sort: true,
          color: true,
          colorEnum: //顏色設定
          {
            999: CONNECTION[0],
            1: CONNECTION[1],
            2: CONNECTION[2],
            4: CONNECTION[1],
          },
          isI18n:
          {
            999: '__common.__fail',
            1: '__common.__success',
            2: '__d7d_n17r.__waitingForReply',
            4: '__common.__successDeleted',
          },
        },
        {
          title: t('__d4e_m8t.__report'),
          customRender: "report", //客製化slot，可用於外接其他組件
          key: "report",
        },
      ]

    })


    const appList2col = computed(() => {
      return [
        {
          title: t('__d4e_m8t.__brightness'),
          key: "brightness",
        },
        {
          title: t('__d4e_m8t.__colorTemperature'),
          key: "colorTemperature"
        },
        {
          title: t('__g3p_m8t.__dynamicRange'),
          key: "dynamicRang",
        },
        {
          title: t('__d4e_m8t.__calibratorType'),
          key: "calibratorType"
        },
        {
          title: t('__c3d_t4t.__colorGamut'),
          key: "gamuts",
        }
      ]
    })

    const modelStatus = computed(() => {
      return {
        'online': t('__g3p_m8t.__online'),
        'offline': t('__g3p_m8t.__offline'),
      }
    })


    const appListColSub = computed(() => {
      return {
        calibrator: t('__d4e_m8t.__calibratorType'),
        presetMode: t('__d4e_m8t.__presetMode', {brand: brand.value}),
        gamut: t('__c3d_t4t.__colorGamut'),
        color_range: t('__g3p_m8t.__dynamicRange'),
        brightness: t('__d4e_m8t.__brightness'),
        gamma: t('__c3d_t4t.__gamma'),
        color_temperature: t('__d4e_m8t.__colorTemperature'),
        coordinate : t('__d4e_m8t.__coordinate'),
        eotf: t('__d4e_m8t.__eotf'),
      }
    })


    watch(
      () => route,
      (to) => {
        // console.log(to)
        let a = to.currentRoute.value.params.tabId
        state.isTabShow = `${a}`;
        pageSettingInit()
        apiPost()
      },
      { deep: true }
    )

    const apiPost = async (isNeedLoading = true) => {
      switch (state.isTabShow) {
        case ACTIONBAR.VIEWAPP:
          await getAPData(isNeedLoading)
          break;
        case ACTIONBAR.VIEWHIS:
          await getETData(isNeedLoading);
          break;
        case ACTIONBAR.SETTING:
          await getETData(isNeedLoading);

          break;
      }
    }

    const pageSettingInit = () => {
      state.meta.current = 0;
      state.meta.total_page = 1;
      state.meta.per_page = 12;
      state.showLimitInfo = false;
      switch (state.isTabShow) {
        case ACTIONBAR.VIEWAPP:
          state.selectVal1 = state.apOption[0]
          break;
        case ACTIONBAR.VIEWHIS:
          state.selectVal1 = state.etOption[0]
          break;
      }

    }


    const getETData = async (isNeedLoading = true) => {
      store.commit('setIsNeedLoading', isNeedLoading);
      const id = route.currentRoute.value.params.name
      console.log(route.currentRoute.value)
      const sendData = {
        page: state.meta.current,
        order: state.order,
        sort: state.sort ? state.sort : 'action_timestamp',
        per_page: state.meta.per_page,
        status: state.selectVal1.val
      }
      try {
        const datas = await apiDeviceExecutedData(id, sendData);
        console.log('apiDevice    ExecutedData', datas)
        if (!datas.status_code) {
          state.modelName = datas.model;
          await getSetting();
          datas.bound_at = dateTimeHandle(datas.bound_at);
          datas.imgUrl = datas.last_page_url;


          if(datas.group){
            let temp  = ''
            for (let j = 0; j < datas.group.length; j++) {
              temp += datas.group[j] + '; '
            }
            datas.group = temp
          }
          datas.group = datas.group ? datas.group : '- - -'

          datas.status = CONNECTION[datas.status]
          for (let i = 0; i < datas.data.length; i++) {
            datas.data[i].action_timestamp = dateTimeHandle(datas.data[i].action_timestamp);

            // datas.data[i].status = IMPLEMENTATION[datas.data[i].status]
            if (datas.data[i].status == 0) {
              datas.data[i].status = 999
            }
            // console.log(datas.data[i].color_range)
            if (datas.data[i].color_range != undefined) {
              datas.data[i].color_range = dynamicRangeHandler(datas.data[i].color_range);
            } else {
              datas.data[i].color_range = ''
            }
            datas.data[i].mode2 = datas.data[i].mode
            datas.data[i].mode = USERMODE[datas.data[i].mode]

          }

          state.settingIcon[0].status = !datas.lock_task; //tbd
          state.settingIcon[1].status = !datas.lock_osd;  //tbd


          state.exeListData = datas.data;
          state.meta.current = datas.current_page;
          state.meta.total_page = datas.last_page;
          state.meta.per_page = datas.per_page;
          state.rawData = datas;

          // console.log('datas', datas.data)

          state.tableETDisableList = state.exeListData.map((e) => {
            return e.status == 'Wait'; //任務狀態在等待執行時不能刪除
          })
          // state.waitForProfile =  datas.osd_apply ? true : false; //等待profile送出後更新(需要10分鐘)，此時profile不能被編輯
          // state.rawData['group'] = state.rawData['group'].join()


          ///0.先判斷 status 是否上線
          // 1. usb_connected = false
          // =>抓osd 的資料 變成disabled
          // 2. usb_connected = true, osd_apply = 有值
          // =>捉osd的資料，結合osd_apply 變成disabled
          // 3. usb_connected osd apply 沒有值
          // 捉osd 的資料，打1-12要到最新的資料
          console.log('status 是否上線', state.rawData['status'])
          if (state.rawData['status'] == 'online') {
            console.log('online')
            if (state.rawData['usb_connected'] == false) {
              console.log('111', 'usb unconnected')
              state.profileList = selectWaitStatus(state.rawData['osd'])
              console.log('111', state.profileList)
              state.waitForProfile = true; //斷線，此時profile不能被編輯，顯示原本設定
            } else {
              if (state.rawData['osd_apply']) {
                //osd apply 申請中有兩個狀態，一個是API告訴我們正在申請中，一個是等候apiDeviceProfile這支API送出去pending的時候
                //此時屬於前者
                console.log('222', '申請中，顯示正在申請中的選項')
                let temp = selectWaitStatus(state.rawData['osd'])//撈取原本設定
                console.log('222', temp)
                for (let i = 0; i < temp.length; i++) {
                  for (let k = 0; k < state.rawData['osd_apply'].length; k++) {
                    if (state.rawData['osd_apply'][k].modeIndex == temp[i].modeIndex) {
                      temp[i]['current'] = {
                        text: state.rawData['osd_apply'][k].setting, //user 送出的值，所以用setting
                        val: state.rawData['osd_apply'][k].setting, //
                      }
                    }
                  }
                }
                state.profileList = temp;
                state.waitForProfile = true; //等待profile送出後更新(需要10分鐘)，此時profile不能被編輯，顯示上次送出的設定
              } else {
                console.log('333', state.isTabShow)
                if (state.isTabShow == ACTIONBAR.SETTING) {
                  state.waitForProfile = false
                  // console.log('??????')
                  await getProfileSetting()
                  currentChange()
                }
              }
            }
          } else {
            console.log('444', '裝置沒有連線')
            state.profileList = selectWaitStatus(state.rawData['osd'])
            console.log('444', state.profileList)
            state.waitForProfile = true; //裝置沒有連線，此時profile不能被編輯，顯示原本設定
          }


        }
      }
      catch (error) {
        return error;
      }
    }



    const getAPData = async (isNeedLoading = true) => {
      store.commit('setIsNeedLoading', isNeedLoading);
      const id = route.currentRoute.value.params.name
      // console.log('routeeee',route.currentRoute.value)
      const sendData = {
        page: state.meta.current,
        order: state.order,
        sort: state.sort ? state.sort == "repeat_type" ? "repeat" : state.sort : 'updated_at',
        per_page: state.meta.per_page,
        status: state.selectVal1.val
      }
      // console.log('sendData', sendData)
      // console.log('sendData', state.rawData)
      try {
        const datas = await apiDeviceApp(id, sendData);
        console.log('api device Appointment', datas)
        if (!datas.status_code) {
          state.modelName = datas.model;
          await getSetting();

          datas.imgUrl = datas.last_page_url;
          datas.bound_at = dateTimeHandle(datas.bound_at);

          if(datas.group){
            let temp  = ''
            for (let j = 0; j < datas.group.length; j++) {
              temp += datas.group[j] + '; '
            }
            datas.group = temp
          }
          datas.group = datas.group ? datas.group : '- - -'
          
          datas.status = CONNECTION[datas.status]
          for (let i = 0; i < datas.data.length; i++) {
            if (datas.data[i].updated_at) {
              datas.data[i].updated_at = dateTimeHandle(datas.data[i].updated_at, 'x');
            }
            datas.data[i].repeat_start_date = dateTimeHandle(datas.data[i].repeat_start_date, 'YYYY.MM.DD');
            if (datas.data[i].next_timestamp) {
              datas.data[i].next_timestamp = dateTimeHandle(datas.data[i].next_timestamp, 'x');
            } else {
              datas.data[i].next_timestamp = null;
            }
            datas.data[i].time_zone = datas.data[i].time_zone > 0 ? `+${datas.data[i].time_zone}` : datas.data[i].time_zone
            if (datas.data[i].repeat_start_min || datas.data[i].repeat_start_min == 0) { //給的分鐘數沒有補0，自己補一下
              if (datas.data[i].repeat_start_min.toString().length < 2) {
                datas.data[i].repeat_start_min = `0${datas.data[i].repeat_start_min}`
                // console.log(datas.data[i].repeat_start_min)
              }
            }
            datas.data[i].time = `${datas.data[i].repeat_start_hour}:${datas.data[i].repeat_start_min} (UTC${datas.data[i].time_zone})`


            let hasTarget = datas.data[i].preset_target ? Array.isArray(datas.data[i].preset_target) ? datas.data[i].preset_target.length : true : false;
            // console.log('hasTarget', hasTarget)
            if (hasTarget) {
              datas.data[i].secondTitle = 'Calibrator'
              datas.data[i].dataInfo = []
              datas.data[i].dataInfo = presetTarget(datas.data[i].preset_target, datas.data[i].calibrator)
              // console.log(datas.data[i].dataInfo,'dataInfo' )
            }
            else {
              // console.log(i,'index')
              datas.data[i].dataInfo = []
              let col = []
              let data = []
              let calibratorName = state.calibrators[datas.data[i].calibrator] || `Unknown Calibrator (ID: ${datas.data[i].calibrator})`;
              let obj = { calibrator: calibratorName, ...datas.data[i].custom_settings }
              // console.log(obj,' why no show my obj')
              // console.log(' why no show my obj',datas.data[i].calibrator)
              if (obj['eotf'] && obj['eotf'] == 2) {  //當eotf數值為2的時候會有brightness_min，兩個都要放進brightness裡面 //0421改
                // obj['brightness'] = obj['brightness_min']
                if (obj['brightness']) {
                  let brightness;
                  if(datas.data[i].calibrator== 4 && ( obj['brightness'] > 650 )){ 
                    brightness = isSpecificCalibrator(obj['brightness'])//特殊規格矯正器限制，最高只能固定650，但給user設定的數字要標註在後面
                  }else{
                    for (const key in BRIGHTNESSMAX) {
                      if (obj['brightness'] == key) {
                        brightness = BRIGHTNESSMAX[key]
                      } else {
                        brightness = ` ${obj['brightness']} ${UNIT.NTM2}`;
                      }
                    }
                  }

                  obj['brightness'] = `${BRIGHTNESSUNIT.lmax} :  ${brightness} <br> ${BRIGHTNESSUNIT.lmin}  : ${obj['brightness_min']} ${UNIT.NTM2}`
                  console.log(brightness)
                } else {
                  obj['brightness'] = `${BRIGHTNESSUNIT.lmin} : ${obj['brightness_min']} ${UNIT.NTM2}`
                }
              } else {
                if (obj['brightness']) {
                  let brightness;
                  if(datas.data[i].calibrator== 4 && ( obj['brightness'] > 650 )){ 
                    brightness = isSpecificCalibrator(obj['brightness'])//特殊規格矯正器限制，最高只能固定650，但給user設定的數字要標註在後面
                  }else{
                    for (const key in BRIGHTNESSMAX) {
                      if (obj['brightness'] == key) {
                        brightness = BRIGHTNESSMAX[key]
                      } else {
                        brightness = ` ${obj['brightness']} ${UNIT.NTM2}`;
                      }
                    }
                  }
                  obj['brightness'] = ` ${brightness}`;
                  // obj['brightness'] = ` ${obj['brightness']} ${UNIT.NTM2}`;
                }
              }

              if (obj['color_temperature'] || obj['color_temperature'] == 0) {
                obj['color_temperature'] = obj['color_temperature'] + 'K';
                // console.log(obj['color_temperature'],"obj['color_temperature']")
              }

              //coordinate start
              if (obj['color_x'] && obj['color_y'] ) {
                obj['coordinate'] = `x : ${obj['color_x']}   y : ${obj['color_y']}`
              }
              //coordinate end


              if (obj['color_range'] || obj['color_range'] == 0) {  //mapping apiSetting 的 color_range
                obj['color_range'] = dynamicRangeHandler(obj['color_range']);
                // console.log(obj['color_range'],"obj['color_range']")
                if (obj['gamut'] || obj['gamut'] == 0) {
                  // 如果是 Custom Gamut (7) 並且有 gamut_custom 資料，在 Gamut 格子中顯示座標
                  if (obj['gamut'] === 7 && obj['gamut_custom']) {
                    const gc = obj['gamut_custom'];
                    obj['gamut'] = `Red(${gc.red_x}, ${gc.red_y}), Green(${gc.green_x}, ${gc.green_y}), Blue(${gc.blue_x}, ${gc.blue_y})`;
                    // 移除 gamut_custom 欄位，避免重複顯示
                    delete obj['gamut_custom'];
                  } else {
                    obj['gamut'] = colorGamutHandler(obj['gamut']);
                  }
                }

                if ((obj['eotf'] || obj['eotf'] === 0)) {  //eotf 有存在
                  obj['eotf'] = eotfHander(obj['eotf'], obj['gamma']);
                  // 如果是 Gamma 類型，移除 gamma 欄位（因為已經包含在 eotf 中）
                  if (obj['gamma'] !== undefined && obj['gamma'] !== null) {
                    obj = Object.fromEntries(Object.entries(obj).filter(([key]) => {
                      return key != 'gamma'
                    }));
                  }
                }
              }
              // console.log(obj, "obj整理過的")
              // console.log( "obj整理過的",state.eotf)
              data.push(obj ? obj : ' ')
              // console.log(data,"data obj放進來的")
              let tempCol = Object.fromEntries(Object.entries(obj).filter(([_, v]) => { return _ && v != null })); //去除value為null 或空值的key
              // let tempCol = Object.fromEntries(Object.entries(obj).filter(() => { return true })); //不去除空直了
              // console.log(tempCol, "tempCol")
              col = Object
                .keys(tempCol)
                .filter(key => key && key != 'brightness_min' && key != 'gamma' && key != 'gamut_custom')  //brightness_min, gamma, gamut_custom 不呈現在 th 上面
                .map((e) => {
                  return {
                    'title': e, //原 PRESET_TITLE[e]
                    'key': e
                  }
                })
              // console.log(col, "col")
              datas.data[i].dataInfo.push({ data: data, col: col })
              // console.log(datas.data[i].dataInfo,"datas.data[i].dataInfo")
            }
          }
          setRepeat(datas.data)

          


          state.meta.current = datas.current_page;
          state.meta.total_page = datas.last_page;
          state.meta.per_page = datas.per_page;
          state.rawData = datas;
          state.appListData = datas.data;

          state.tableAPDisableList = state.appListData.map((e) => {
            return e.group ? true : false; //group有值的話不能刪除
          })

        }
      }
      catch (error) {
        return error;
      }
    }

    const isSpecificCalibrator = (val) => { //特殊規格矯正器限制，最高只能固定650，但給user設定的數字要標註在後面
      for (const key in BRIGHTNESSMAX) {
          if(val == key){
            return `650 (${BRIGHTNESSMAX[key]}) ${UNIT.NTM2}`
          }else{
            return `650 (${val}) ${UNIT.NTM2}`
          }
        }
    }



    const selectWaitStatus = (selectArr) => {
      console.log('selectWaitStatus ===> osd', selectArr)
      if (selectArr) {
        selectArr.forEach((e) => {
          e['option'] = []
        })
        for (let i = 0; i < selectArr.length; i++) {
          if (selectArr[i]['currentSetting']) {
            selectArr[i]['current'] = {
              text: selectArr[i].currentSetting,
              val: selectArr[i].currentSetting,
            }
          } else {
            selectArr[i]['current'] = {
              text: 'Factory Default',
              val: 'Factory Default',
            }
          }

          selectArr[i]['disable'] = false
          for (let k = 0; k < selectArr[i].settingList.length; k++) {
            selectArr[i]['option'].push({
              text: selectArr[i].settingList[k],
              val: selectArr[i].settingList[k]
            })
          }
          // selectArr[i]['disable'] = true;
        }
        return selectArr
      }


    }


    const getProfileSetting = async () => {
      let deviceId = state.rawData['id']
      try {
        const datas = await apiDeviceGetProfile(deviceId);
        console.log('api Device Get Profile', datas)
        state.profileList = datas.data
        state.profileList.forEach((e) => {
          e['option'] = []
          if (e.modeName != USERMODE[1] && e.modeName != USERMODE[2]) {
            e['option'].push({
              text: 'Factory Default',
              val: 'Factory Default',
            })
          }

        })
        // console.log('state.deviceCheck 1', state.deviceCheck)
        state.deviceCheck = []
        for (let i = 0; i < state.profileList.length; i++) {
          state.profileList[i]['current'] = {
            text: state.profileList[i].currentSetting,
            val: state.profileList[i].currentSetting,
          }
          state.profileList[i]['disable'] = false;
          if (state.profileList[i].settingList.length) {
            for (let k = 0; k < state.profileList[i].settingList.length; k++) {
              state.profileList[i]['option'].push({
                text: state.profileList[i].settingList[k],
                val: state.profileList[i].settingList[k]
              })
            }
          } else {
            state.profileList[i]['option'].push({
              text: state.profileList[i].currentSetting,
              val: state.profileList[i].currentSetting
            })
          }

          //如果沒有下拉選單，前端這邊先塞入Factory Default 且disable
          if (!state.profileList[i].settingList.length && state.profileList[i].currentSetting === 'Factory Default') {
            // console.log(state.profileList[i].settingList.length, state.profileList[i].settingList[0] === 'Factory Default')
            state.profileList[i]['disable'] = true;
          }

          let mode = state.profileList[i].modeName.indexOf('Mode') > -1 ? ' ' : 'mode';
          let preset = state.profileList[i].modeName.indexOf('User') > -1 ? ' ' : 'Preset';
          // console.log(state.profileList[i].modeName, preset)
          if (state.profileList[i].modeName != USERMODE[1] && state.profileList[i].modeName != USERMODE[2]) {
            state.deviceCheck.push({
              title: `${preset} ${state.profileList[i].modeName} ${mode}`,
              name: state.profileList[i].modeName,
              val: false,
            })
          }

        }

        // console.log('state.deviceCheck 2', state.deviceCheck)

        console.log('enddd', state.waitForProfile)
        state.compare = JSON.parse(JSON.stringify(state.profileList));


      }
      catch (error) {
        console.log('error!!!', error)
        return error;
      }
    }

    const presetTarget = (target, calibrator) => {

      // console.log('target',target)
      let arr = []
      for (let k = 0; k < target.length; k++) {
        let col = []
        let data = []
        let calibratorName = state.calibrators[calibrator] || `Unknown Calibrator (ID: ${calibrator})`;
        let obj = { calibrator: calibratorName, ...state.preset[target[k]], presetMode: state.preset[target[k]].name }

        if (obj['color_range']) {
          if (obj['eotf']) {
            if (state.eotf && state.eotf[obj['color_range']]) {
              let temp = Object.keys(state.eotf[obj['color_range']]).find(key =>  //把Gamma找出來比對
                key == 'Gamma'
              );
              if (temp == obj['eotf']) {
                obj['eotf'] = `${obj['eotf']}  ${obj['gamma']}`
                obj = Object.fromEntries(Object.entries(obj).filter(([key]) => {
                  return key != 'gamma'
                }));
              }
            }
          }
        }
        // 處理 Gamut
        if (obj['gamut'] || obj['gamut'] == 0) {
          if (obj['gamut'] === 7 && obj['gamut_custom']) {
            const gc = obj['gamut_custom'];
            obj['gamut'] = `Red(${gc.red_x}, ${gc.red_y}), Green(${gc.green_x}, ${gc.green_y}), Blue(${gc.blue_x}, ${gc.blue_y})`;
            delete obj['gamut_custom'];
          } else {
            obj['gamut'] = colorGamutHandler(obj['gamut']);
          }
        }
        if (obj['brightness']) {
          obj['brightness'] = `${obj['brightness']} ${UNIT.NTM2}`
        }

        data.push(obj ? obj : ' ')
        // let tempCol = Object.fromEntries(Object.entries(obj).filter(([_, v]) => { return _ && v != null })); //去除value為null 或空值的key
        //[_, v]
        let tempCol = Object.fromEntries(Object.entries(obj).filter(() => { return true }));

        col = Object
          .keys(tempCol) //tempCol
          .filter(key => key && key != 'name' && key != 'id' && key != 'color_range' && key != 'gamma' && key != 'gamut_custom')  //name, id, color_range, gamma, gamut_custom 不呈現在 th 上面
          .map((e) => {
            return {
              'title': e, //原 PRESET_TITLE[e]
              'key': e
            }
          })
        arr.push({ data: data, col: col })
      }
      return arr
    }


    const setAppListColSub = (e) => {
      let temp = []
      // console.log('setAppListColSub',e)
      for (let key in appListColSub.value) {
        for (let i = 0; i < e.length; i++) {
          if (key == e[i].title) {
            temp.push({
              'title': appListColSub.value[key],
              'key': e[i].key
            })
          }
        }

      }
      // console.log(temp)
      return temp
    }



    const getSetting = async () => {
      const sendData = {
        model: state.modelName,
      }
      try {
        const datas = await apiSettings(sendData);
        // console.log('apiSettings', datas)
        state.preset = datas.data.model.preset_modes;
        datas.data.calibrators.forEach((item) => {
          state.calibrators[item.id] = item.name
        })
        state.colorRange = datas.data.color_range
        state.eotf = datas.data.eotf
        state.gamut = datas.data.gamut
      }
      catch (error) {
        return error;
      }
    }


    const queryModels = async () => {
      try {
        const datas = await apiGetGroupModel();
        // console.log('apiGetGroupModel',datas)
        if (!datas.status_code) {
          state.modelList = datas.model
        }
      }
      catch (error) {
        return error;
      }
    }


    const geCVS = async () => {
      let id = []
      id.push(state.rawData['id'])
      const sendData = {
        id: id,
      }
      try {
        const datas = await apiCSV(sendData);
        // console.log('apiCSV', datas)
        let date = dateTimeHandle(new Date(), "YYYYMMDD_HHmm", "YYYYMMDD_HHmm")
        const url = window.URL.createObjectURL(new Blob([datas]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${date}.csv`);
        document.body.appendChild(link);
        link.click();
      }
      catch (error) {
        return error;
      }
    }



    //- PA32UCR_AA1500072-PC
    const setUnbind = async () => {
      let arr = []

      arr.push(state.rawData)
      console.log(arr)
      const modalConfig = {
        type: POPUP.DEVICEUNBIND,
        data: {
          list: arr,
          action: true
        },
        isShow: true,
      }
      store.commit('setIsShowModal', modalConfig)
    }


    const editDeviceSetting = async () => {
      let deviceId = state.rawData['id']
      const sendData = {
        lock_task: !state.settingIcon[0].status,
        lock_osd: !state.settingIcon[1].status,
      }
      try {
        const datas = await apiDeviceSetting(deviceId, sendData);
        console.log('apiDevice Setting', datas)
        if (!datas.status_code) {
          apiPost()
          store.commit('setFlashMsg', { data: `${state.rawData['model']} ${t('__flash.__permissionSettingsApplySuccessfully')}`, isShow: true })
          // storeState.isShowFlashMsg = true;
          // storeState.flashMsgText = 'Apply Successfully'
          ///
        }
      }
      catch (error) {
        return error;
      }
    }

    const applyProfile = async (isNeedLoading = true) => {    //tbd
      console.log(state.profileList)
      let compare = []
      for (let i = 0; i < state.profileList.length; i++) {
        for (let k = 0; k < state.compare.length; k++) {
          if (state.compare[k].modeIndex === state.profileList[i].modeIndex) {
            if (state.compare[k]['current'].val != state.profileList[i]['current'].val) {
              compare.push({
                modeIndex: state.profileList[i].modeIndex,
                setting: state.profileList[i]['current'].val, //設定給阿邦那是setting
              })
            }
          }
        }
      }
      if (!compare.length) {
        // console.log('沒有改東西啊')
        // console.log('有動過的', state.profileList)
        // console.log('原本的', state.compare)
        return
      }
      console.log('compare left', compare)
      let deviceId = state.rawData['id']
      const sendData = {
        profiles: compare
      }

      try {
        store.commit('setIsNeedLoading', isNeedLoading);
        //osd apply 申請中有兩個狀態，一個是API告訴我們正在申請中，一個是等候apiDeviceProfile這支API送出去pending的時候
        //後者因為太久了，message port會等不到response，頁面無法根據回復更新按鈕與狀態，造成使用者可以操作顯示不正確的畫面
        state.waitForProfile = true;
        state.rawData['osd_apply'] = true;
        //osd apply 申請中有兩個狀態，一個是API告訴我們正在申請中，一個是等候apiDeviceProfile這支API送出去pending的時候
        //後者因為太久了，message port會等不到response，頁面無法根據回復更新按鈕與狀態，造成使用者可以操作顯示不正確的畫面
        const datas = await apiDeviceProfile(deviceId, sendData);
        console.log('apiDevice Profile ', datas)
        if (!datas.status_code) {
          // 
          store.commit('setFlashMsg', { data: `${t('__flash.__applySuccessfully')}`, isShow: true })
          // storeState.isShowFlashMsg = true;
          // storeState.flashMsgText = `${state.rawData['model']}  OSD Profile Apply Successfully`
          apiPost()
        } else {
          if (datas.status_code == 4 || datas.status_code == 5) {
            checkUSBConnected()
          }
        }
      }
      catch (error) {
        console.log(error.response, 'error response!!!')
        if (error.response.data.status_code == 4 || error.response.data.status_code == 5) {
          checkUSBConnected()
        } else {
          store.commit('setFlashMsg', { data: `${t('__flash.__applyFailed')}`, isShow: true })
          apiPost()
        }
        return error;
      }
    }

    const currentChange = () => {
      let compare = []
      for (let i = 0; i < state.profileList.length; i++) {
        for (let k = 0; k < state.compare.length; k++) {
          if (state.compare[k].modeIndex === state.profileList[i].modeIndex) {
            if (state.compare[k]['current'].val != state.profileList[i]['current'].val) {
              compare.push({
                modeIndex: state.profileList[i].modeIndex,
                setting: state.profileList[i]['current'].val, //設定給阿邦那是setting
              })
            }
          }
        }
      }
      state.noChange = compare.length ? false : true;


    }


    const checkUSBConnected = () => {
      const modalConfig = {
        type: POPUP.DEVICENOTIFICATION,
        data: {
        },
        isShow: true,
      }
      store.commit('setIsShowModal', modalConfig)
      // apiPost() //重新取得裝置無連線的狀態
    }




    const setRepeat = (v) => {
      v.forEach(e => {
        if (e.repeat_cycle) {
          if(REPEAT_TYPE[e.repeat_type] =='week'){

            e.repeatCol = t('__d4e_m8t.__repeatEveryNumWeek',{num : `  ${e.repeat_cycle}`}) ;
          }else{
            e.repeatCol = t('__d4e_m8t.__repeatEveryNumMonth',{num : `  ${e.repeat_cycle}`}) ;
          }
        } else {
          e.repeatCol = 'Single'
        }
      });

    }

    const setRepeatCol = (e) => {
        if (e.repeat_cycle) {
          if(REPEAT_TYPE[e.repeat_type] =='week'){
            return t('__d4e_m8t.__repeatEveryNumWeek',{num : `  ${e.repeat_cycle}`}) ;
          }else{
            return t('__d4e_m8t.__repeatEveryNumMonth',{num : `  ${e.repeat_cycle}`}) ;
          }
        } else {
          return 'Single'
        }
    }
    
    const modeCol = (data, col) => {
      if(data[col.key] == 1 || data[col.key] == 2 ||  data[col.key] == 3){
        return t('__d4e_m8t.__userMode') + ' ' + data[col.key]
      }else if(data[col.key] == 0){
        return t('__d4e_m8t.__presetMode', {brand: brand.value})
      }else{
        return '- - -'
      }
    }
    


    const deleteET = async () => {
      console.log(state.list, 'deleteET')
      let id = []
      id = state.list.map(item => item.id);
      const sendData = {
        id: id,
        appointment: false,
      }
      try {
        const datas = await apiDeleteTask(sendData);
        console.log('apiDeleteTask', datas)
        if (!datas.status_code) {
          apiPost()
          state.list = [];
          state.defaultCheckIndexList = [];
        }
      }
      catch (error) {
        return error;
      }
    }





    const deleteAP = async () => {
      console.log(state.list)
      let id = []
      id = state.list.map(item => item.id);
      const sendData = {
        id: id,
      }
      try {
        const datas = await apiDeleteAppointment(sendData);
        console.log('apiDelete Appointment', datas)
        if (!datas.status_code) {
          apiPost()
          state.list = []
          state.defaultCheckIndexList = [];
        }
      }
      catch (error) {
        return error;
      }
    }



    const setCalibration = () => {
      let temp = []
      temp.push(state.rawData)
      store.commit('setCalibrationList', { title: 'device', content: temp });
      route.push({ name: FEATURENAME.CALIBRATION });
    }








    const onClickTab = (v) => {
      let fullPath = route.currentRoute.value.fullPath.split("/")
      let path = fullPath.filter((element, index) => index < fullPath.length - 1).join('/');
      route.push(`${path}/${v.item.val}`);
      state.selectVal1 = {
        text: '請選擇',
        val: 'default',
      }
    }


    const report = (i) => {
      if (i.report) {
        window.open(i.report)
      }
    }

    const editApp = (i) => {
      const modelId = state.rawData['id']
      console.log(i.id, 'iojkgigifjnbia', modelId)
      route.push(`/main/calibration/modify/device/${modelId}/${i.id}`);
    }


    const changePage = (page) => {
      state.meta.current = page;
      state.defaultCheckIndexList = [];
      if(page != 1){
        apiPost()
      }
    }
    const tableSort = (v) => {
      console.log(v, 'sort table')
      state.order = v.val === 'up' ? 'asc' : 'desc';
      state.sort = v.key;
      if (state.isTabShow == ACTIONBAR.VIEWAPP) {
        switch (v.key) {
          case 'repeatCol':
            state.sort = 'repeat_type'
            break;
        }

      }
      // console.log('state.sort', state.sort)

      state.defaultCheckIndexList = [];
      apiPost()
    }

    const onCheckAll = (v) => {
      // console.log(v, 'table onCheck All')
      state.defaultCheckIndexList = [];
      state.list = v;
      v.forEach(itm => state.defaultCheckIndexList.push(itm.tableId));
    }

    const onCheckEach = (v) => {
      // console.log(state.list, 'table onCheck Each')
      state.defaultCheckIndexList = [];
      state.list = v;
      v.forEach(itm => state.defaultCheckIndexList.push(itm.tableId));

    }

    const goTableLink = (v) => {
      console.log(v, 'table link')
    }

    const selectChange = (v) => {
      if (v) {
        state.meta.current = 1
        state.defaultCheckIndexList = [];
        apiPost()
      }
    }

    const showCTAndRow = (v) => {
      console.log(v, 'show ??? ContextMenu')
    }

    const selectContextMenu = (v) => {
      console.log(v, 'show ContextMenu')
    }

    const applyCalibration = (data) => {
      console.log('applyToCalibration', data)
    }

    const settingLock = (e) => {
      e.status = !e.status
    }


    const store = useStore()
    const storeState = store.state;

    const reset = () => {
      const modalConfig = {
        type: POPUP.DEVICERSET,
        data: {
          list: state.deviceCheck,
        },
        isShow: true,
      }
      store.commit('setIsShowModal', modalConfig)
    }

    

    const resetFrom = (v) => {
      console.log(v, 'reset form')
      const resetSelect = { text: 'Factory Default', val: 'Factory Default' }
      // console.log(state.profileList.find(x => x.modeName === 'User Mode 1')['current'],'kokokok');
      // state.profileList.find(x => x.modeName === 'User Mode 1')['current'] = resetSelect
      for (let i = 0; i < v.length; i++) {
        if (v[i].val) {
          console.log(v[i].name)
          state.profileList.find(x => x.modeName === v[i].name)['current'] = resetSelect
        }
        state.deviceCheck[i].val = false;
      }
    }





    store.watch((state) => (state.wsData), () => { //websocket 的資料有更新的
      console.log('websocket 的資料有更新的 store.state.wsData', store.state.wsData)
      console.log('websocket 的資料有更新的', storeState.wsData)
      console.log('本頁的ssn', state.rawData['ssn'], 'ws的ssn', storeState.wsData['device'])
      console.log('本頁的ssn與ws的ssn相等嗎?', state.rawData['ssn'] == storeState.wsData['device'])
      if (storeState.wsData['device'] == state.rawData['ssn']) { //確認是這頁的裝置設定有回應了
        console.log('比對ssn成功')
        apiPost()
        console.log('重新打完api了')
      } else {
        console.log('比對ssn失敗')
      }
    }, {
      deep: true
    })



    store.watch((state) => (state.isShowModal, state.modalType), (newType, oldType) => {
      // modal type
      if (oldType === POPUP.DEVICERSET) {
        console.log('storeState.modalBtnType', storeState.modalBtnType);
        // modal btn type 決定要幹嘛
        if ((storeState.modalBtnType).indexOf(BTN.CONFIRM) > -1) {
          const output = storeState.modalOutput
          resetFrom(output)
        } else {

          for (let i = 0; i < state.deviceCheck.length; i++) {
            state.deviceCheck[i].val = false;
          }
        }
      } else if (oldType === POPUP.DEVICENOTIFICATION) {
        if ((storeState.modalBtnType).indexOf(BTN.CANCEL) > -1) {
          // console.log(output,'output')
          apiPost()
        }
      } else if (oldType === POPUP.DEVICEUNBIND) {
        if ((storeState.modalBtnType).indexOf(BTN.CONFIRM) > -1) {
          const output = storeState.modalOutput;
          // console.log(output,'output')
          deleteGroup(output)
        }
      }
    })

    const showGroupName = (e, item) => {
      state.left = e.target.getBoundingClientRect().left;
      state.top = e.target.getBoundingClientRect().top;
      state.detail = state.rawData[item.val];
    }

    const handleFocusOut = () => {
      // state.detail = ''
    }

    const handleLimitOut = () => {
      state.showLimitInfo = false
    }



    const dataLimitInfo = () => {
      console.log('gkgkg')
      state.showLimitInfo = true
    }


    const itemClass = computed(
      () => {
        return {
          top: `${state.top + 30}px`,
          left: `${state.left}px`
        }
      }
    )

    const textLimitHoverPopup = () => {

      let target = null;
      target = deviceDetailPage.value;
      setTimeout(() => {
        if (!target) return
        let a = target.querySelectorAll('.li')
        // let b = target.querySelectorAll('.tooltips')
        for (let i = 0; i < a.length; i++) {
          if (a[i].scrollHeight > a[i].clientHeight) {
            state.modelCol[i]['show'] = true
            a[i].classList.add('overTextLimit')
          } else {
            state.modelCol[i]['show'] = false
            a[i].classList.remove('overTextLimit')
          }
        }
      }, 1)
    }

    //websocket text
    const testWs = () => {
      let test = {
        device: state.rawData['ssn'],
        action: "osd_result",
        result: state.consoleLog,
        reason: "null",
        handleCode: "null",
        timestamp: "1584929511",
      }
      store.commit('setWsData', test)

    }

    const changeWSResult = () => {

      state.consoleLog = !state.consoleLog;
      testWs()
      console.log(storeState.wsData)
    }


    const deleteGroup = async (output) => {
      const sendData = {
        id: output.arr,
      }
      try {
        const datas = await apiDeleteDevice(sendData);
        console.log('apiDeleteDevice', datas)

        route.push({ name: FEATURENAME.DEVICE });
      }
      catch (error) {
        return error;
      }

    }



    const transferDepictionCode = (errorcode,valText) => {
      if(errorcode[valText]){
        return t(errorcode[valText])
      }else{
        return t(errorcode[100])
      }
      
    }








    return {
      textLimitHoverPopup,
      state,
      deviceDetailPage,
      onClickTab,
      setCalibration,
      tableSort,
      onCheckAll,
      onCheckEach,
      goTableLink,
      showCTAndRow,
      selectContextMenu,
      applyCalibration,
      changePage,
      report,
      settingLock,
      reset,
      getETData,
      apiPost,
      getSetting,
      queryModels,
      deleteET,
      selectChange,
      getAPData,
      presetTarget,
      setRepeat,
      editApp,
      deleteAP,
      geCVS,
      editDeviceSetting,
      getProfileSetting,
      resetFrom,
      applyProfile,
      pageSettingInit,
      showGroupName,
      handleFocusOut,
      itemClass,
      selectWaitStatus,
      dataLimitInfo,
      handleLimitOut,
      testWs,
      changeWSResult,
      checkUSBConnected,
      setUnbind,
      deleteGroup,
      currentChange,
      t,
      tabText,
      appListCol,
      exeListCol,
      appList2col,
      appListColSub,
      setAppListColSub,
      modelStatus,
      ERRORDESC,
      isSpecificCalibrator,
      transferDepictionCode,
      setRepeatCol,
      modeCol
    }
  }// end: setup

}



